module.exports = __webpack_public_path__ + "img/user-tg-icon.afe0cc98.png";